<template>

    <div class="action-area">
        <template v-if="size > 0">
            <a class="btn-download"
                v-if="size > 0"
                :class="getTooltipClass(fileType)"
                @click="goDownload"
            >
                <div class="file-type dark">
                    <p :class="getTooltipClass(fileType)"
                       :tooltip="getTooltip()" flow="down">{{ formatUpperCase }}</p>

                </div>
            </a>

            <template v-if="$mq === 'narrow' && has_preview_column">
                <HkepPreviewButton
                    v-bind:allow_before_login="allow_before_login"
                    v-bind:preview_url="preview_url"
                    v-bind:url="url"
                    v-bind:has_preview="has_preview"
                    v-bind:fileType="fileType"
                    v-bind:id="id"
                    v-bind:item="item"

                >
                </HkepPreviewButton>

            </template>
        </template>

        <template v-else-if="resource_url">
            <a class="btn-download" href="javascript:void(0)" @click="goUrl()" :class="getTooltipClass('url')">
                <div class='file-type dark'>
                    <p :class="getTooltipClass('url')" :tooltip="getTooltip()" flow="down">URL</p>
                </div>
            </a>
        </template>
    </div>

</template>

<script>

    import Vue from 'vue';
    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';
    import EventBus from '@common/eventBus';
    import XAPIJS from 'xapijs';
    import HkepPreviewButton from '@/HkepPreviewButton';

    export default {
        name: "HkepDisplayFormatSize",
        mixins:[common,storeMapper],
        data() {
            return {
                is_downloading: false,
                is_demo_user: is_demo_user

            }
        },
        components: {
            HkepPreviewButton
        },
        props: {
            url: {
                default: "",
                type: String
            },
            fileType: {
                default: "",
                type: String
            },
            size: {
                default: 0,
                type: Number
            },
            download_display_type: {
                default: "single",
                type: String
            },
            resource_url: {
                default: "",
                type: String
            },
            filename: {
                default: "",
                type: String
            },
            id: {
                default: "",
                type: String
            },
            allow_before_login: {
                default: "Y",
                type: String
            },
            preview_url: {
                default: "",
                type: String
            },
            has_preview: {
                default: false,
                type: Boolean
            },
            has_preview_column: {
                default: false,
                type: Boolean
            },
            item: {
                default: {}
            }
        },
        computed: {
            format_size: function() {
                return this.formatSize(this.size);
            },
            formatUpperCase() {
                return this.formatToUpperCase(this.fileType);
            }
        },
        methods: {
            getTooltipClass(fileType)
            {
                if (is_demo_user && !this.item.allow_download) {
                    return "demo-btn dark file-"+fileType;
                }
                return "dark file-"+fileType;
            },
            getTooltip()
            {
                if (is_demo_user && !this.item.allow_download) {
                    return this.lang(this.$t('Authorization required download')).toLowerCase();
                }
                return this.lang(this.$t('Download')).toLowerCase();
            },
            goUrl() {
                let self = this;
                if (is_demo_user && !this.item.allow_download) {
                    return false;
                }

                if (self.allow_before_login === "Y") {
                    window.open(self.resource_url, "_blank");
                } else {
                    if (self.checkIsLoggedIn()) {
                        window.open(self.resource_url, "_blank");
                    } else {
                        EventBus.$emit("showLogin");
                    }
                }
            },
            goDownload()
            {

                if (is_demo_user && !this.item.allow_download) {
                    return false;
                }

                let self = this;
                let allow = false;
                if (self.allow_before_login === "Y") {
                    allow = true;
                } else {
                    if (self.checkIsLoggedIn()) {
                        allow = true;
                    }
                }

                //check mp3 / mp4
                if (((this.fileType === "mp4" && this.checkIsIOS()) || (this.fileType === "mp4" &&  this.checkIsAndroid())) && allow) {

                    var url = window.mp4Page+encodeURIComponent(this.id);
                    window.open(url, "_blank");
                    self.is_downloading = false;

                } else if ((this.fileType === "mp3" && this.checkIsIOS()) && allow) {

                    var url = window.mp3Page+encodeURIComponent(this.id);
                    window.open(url, "_blank");

                    self.is_downloading = false;

                } else if (this.checkIsSafari() && allow) {

                    window.open(this.url, "_blank");
                    self.is_downloading = false;

                } else if (!self.is_downloading && allow) {
                    self.is_downloading = true;

                    EventBus.$emit("showGlobalLoading");

                    jQuery.ajax({
                        url: self.url,
                        method: 'GET',
                        xhrFields: {
                            responseType: 'blob'
                        },
                        success: function (data) {
                            var a = document.createElement('a');
                            var url = window.URL.createObjectURL(new Blob([data]));
                            a.href = url;
                            a.download = self.filename;
                            document.body.append(a);
                            a.click();
                            a.remove();
                            window.URL.revokeObjectURL(url);

                            self.is_downloading = false;

                            EventBus.$emit("hideGlobalLoading");

                        },
                        error: function(xhr, ajaxOptions, thrownError)
                        {
                            self.is_downloading = false;
                            EventBus.$emit("hideGlobalLoading");

                        }

                    });




                    let xapijs = new XAPIJS(xapi_config, access_token);

                    xapijs.downloadFile(
                        display_name,
                        membercode,
                        this.filename,
                        this.url,
                        this.fileType
                    );
                } else {
                    console.log(allow);
                    if (!allow) {
                        EventBus.$emit("showLogin");
                    }
                }

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/HkepDisplayFormatSize.vue